import { Fragment, useEffect, useMemo, useState } from "react";
import { ShowLinkPreview } from "../../utils/Utils";
import { UserDetailModal } from "../avatar/UserDetailModal";
import apiFactory from "../../api";
import { renderMessage } from "../chat/renderMessage"; // <-- Đã thêm từ phiên bản 2

const ShowContent = ({ content, isMention, previewLink }) => {
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [modalUser, setModalUser] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const renderLineContent = (line, isMention, previewLink) => {
        if (!line) return null;

        const regex = /(@\[([^\]]+)\]\(([^)]+)\))|(https?:\/\/[^\s<>]+)/g;
        const parts = line.split(regex);
        const result = [];

        for (let i = 0; i < parts.length; i++) {
            const part = parts[i];
            if (!part) continue;

            const partIndex = i % 5;

            if (partIndex === 0) {
                result.push(<Fragment key={i}>{renderMessage(part)}</Fragment>);
            } else if (partIndex === 1) {
                const displayName = parts[i + 1];
                const userId = parts[i + 2];

                if (isMention) {
                    result.push(
                        <span
                            key={i}
                            className={`mention-text ${
                                userId !== "ALL" && !isLoading
                                    ? "hover:underline cursor-pointer"
                                    : ""
                            }`}
                            onClick={() => {
                                if (userId === "ALL" || isLoading) return;
                                setIsLoading(true);
                                setSelectedUserId(userId);
                            }}
                        >
              @{displayName}
            </span>
                    );
                } else {
                    result.push(<span key={i}> @{displayName} </span>);
                }
                i += 3;
            } else if (partIndex === 4) {
                const singleLink = !previewLink?.image;
                result.push(
                    <a
                        key={i}
                        href={part}
                        className={`url ${
                            singleLink ? "no-underline text-[#005ae0] break-all" : ""
                        }`}
                        target="_blank"
                        rel="noreferrer"
                        style={
                            singleLink
                                ? {
                                    maxWidth: "auto",
                                    fontSize: ".9375rem",
                                    fontWeight: "400",
                                    lineHeight: "1.5",
                                }
                                : {}
                        }
                    >
                        {part}
                    </a>
                );
            }
        }

        return result;
    };

    const formattedContent = useMemo(() => {
        if (!content) return null;

        const lines = content.split("\n");

        return (
            <>
                {lines.map((line, lineIndex) => (
                    <Fragment key={lineIndex}>
                        {lineIndex !== 0 && <br />}
                        {renderLineContent(line, isMention, previewLink)}
                    </Fragment>
                ))}
                {previewLink?.image && <ShowLinkPreview previewLink={previewLink} />}
            </>
        );
    }, [content, isMention, previewLink]);

    useEffect(() => {
        if (!selectedUserId || selectedUserId === "ALL") {
            setIsLoading(false);
            return;
        }

        const abortController = new AbortController();
        const { signal } = abortController;

        const getUserInfo = async () => {
            try {
                const rs = await apiFactory.userApi.getUser(selectedUserId, signal);

                if (rs?.status !== 200) return;

                setModalUser(rs?.data);
                setIsLoading(false);
            } catch (error) {
                if (error.name !== "AbortError") {
                    setIsLoading(false);
                    setSelectedUserId(null);
                }
            }
        };

        getUserInfo();

        return () => {
            abortController.abort();
            setIsLoading(false);
        };
    }, [selectedUserId]);

    return (
        <div
            className={`${
                previewLink?.image && "max-w-[400px]"
            } w-[100%] ${isLoading ? "cursor-wait" : ""} leading-[26px]`} // <-- Thêm 'leading-[26px]' từ phiên bản 2
        >
            {formattedContent}

            {modalUser && (
                <UserDetailModal
                    person={modalUser}
                    isOpen={!!modalUser}
                    handleCancel={() => {
                        setSelectedUserId(null);
                        setModalUser(null);
                    }}
                />
            )}
        </div>
    );
};

export default ShowContent;